// extracted by mini-css-extract-plugin
export default {"fields":"_1c5zM","month":"_3eook","day":"NTS9b","year":"_10WBp"};